import appConfig from 'config/app/app-config';

export default {
  initialize() {
    const gtamId = appConfig.analytics.gtm.id;
    const headTag = document.getElementsByTagName('head')[0];

    const script1 = document.createElement('script');
    const script1Code = document.createTextNode(`

      /* <!-- Google Tag Manager --> */
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtamId}');

    `);
    script1.appendChild(script1Code);
    headTag.insertBefore(script1, headTag.firstChild);
  }
};
